module.exports = __webpack_public_path__ + "static/media/0191_Medium.13748868.jpg";